import * as React from "react";
import { Outlet } from "react-router-dom";
import { getInspection } from "@app/models/inspection";
import Stepper from "@app/components/Stepper";
import { getInspectionConfig } from "@app/models/inspectionConfig";
import { useWizardSteps } from "@app/lib/hooks/useWizardSteps";
import { INITIAL } from "@app/constants/Constants";

export async function loader(request) {
    const { params } = request;
    const { inspectionId } = params;

    // load inspection form config
    const inspectionConfig = await getInspectionConfig();
    if (!inspectionConfig) {
        throw new Response("", {
            status: 500,
            statusText: "Inspection config at inspection at layout not available",
        });
    }

    const inspection = !inspectionId
        ? // case: new inspection. new item will be created
          null
        : // load the current inspection data set
          await getInspection(inspectionId);

    if (inspection?.type === INITIAL) {
        // inspection.filter()
    }

    if (inspection !== null && !inspection) {
        throw new Response("", {
            status: 404,
            statusText: "Not Found",
        });
    }

    return { inspection, inspectionConfig };
}

function InspectionStepper() {
    const steps = useWizardSteps();
    return steps && <Stepper total={steps.total} active={steps.current} />;
}

export default function InspectionLayout() {
    return (
        <>
            <InspectionStepper />
            <Outlet />
        </>
    );
}
